import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import config from "../configuration/config";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";

SwiperCore.use([Pagination, Autoplay]);

export function WhyHJSection({ secondTheme = false, subtitle, title }) {
    const { t: trans, i18n } = useTranslation(["eparts", "info"]);
    let lang = (i18n.language || 'ar');
    const [whyInfo, setWhyInfo] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        async function fetchData() {
            try {
                if ("caches" in window) {
                    let url = "WhyHj-" + lang;
                    const cacheStorage = await caches.open("HJWeb");
                    const cachedResponse = await cacheStorage.match(url);
                    let data = await cachedResponse?.json();
                    if (data?.data) setWhyInfo(data.data);
                }

                const response = await axios.request({
                    baseURL: config.controllURL,
                    url: lang + "/api/sections/WhyHj",
                    method: "get",
                });

                if (response.data) {
                    setWhyInfo(response.data);
                    if ("caches" in window) {
                        const dataResponse = new Response(JSON.stringify({ data: response.data }));
                        caches.open("HJWeb").then((cache) => {
                            cache.put("WhyHj-" + lang, dataResponse);
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
        fetchData();
    }, [lang]);

    const renderCard = (item, index) => (
        <div className="why-card" key={index}>
            <div className="why-icon">
                <img
                    src={item.imagePath ? config.FilePathURL + item.imagePath : "/assets/images/default.png"}
                    alt={item.name}
                    onError={(e) => {
                        if (!e.target.dataset.fallback) {
                            e.target.dataset.fallback = "1";
                            e.target.src = "/assets/images/default.png";
                        }
                    }}
                    style={{ width: 32, height: 32 }}
                />
            </div>
            <h3 className="why-card-title">{item.name}</h3>
            <p className="why-card-text">{item.content}</p>
        </div>
    );

    return (
        <section className="sec why-hj-section" style={{ paddingTop: 20, paddingBottom: 15 }}>
            <div className="ctn">
                <div className="why-header">
                    <h2 className="sh">
                        {
                            (title ? title.replace(/<br\s*\/?>/gi, ' ') : trans("eparts:WhyHj").replace(/<br\s*\/?>/gi, ' '))
                                .split(' ')
                                .map((word, i, arr) =>
                                    i >= arr.length - 2 ? (
                                        <span key={i} className="gn">
                                            {word + ' '}
                                        </span>
                                    ) : (
                                        word + ' '
                                    )
                                )
                        }                    </h2>
                </div>

                {isMobile ? (
                    <div className="why-swiper-container" style={{ width: '100%', padding: '10px 0 40px' }}>
                        <Swiper
                            spaceBetween={8}
                            slidesPerView={2.2}
                            pagination={{ clickable: true }}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            observer={true}
                            observeParents={true}
                            watchSlidesProgress={true}
                            breakpoints={{
                                480: { slidesPerView: 2.5 },
                                768: { slidesPerView: 3.5 }
                            }}
                            className="why-swiper"
                        >
                            {whyInfo.map((item, index) => (
                                <SwiperSlide key={index}>
                                    {renderCard(item, index)}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                ) : (
                    <div className="why-grid-container">
                        {whyInfo.map((item, index) => renderCard(item, index))}
                    </div>
                )}
            </div>
        </section>
    );
}
